import React from 'react';
import { Col, Row } from './RowCol';
import Spacer from './Spacer';

type Props = {
	label: string;
	number: number;
	edit: (newNumber: number) => void;
};
type State = {
	input: string;
};

class NumberEditor extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);

		this.state = {
			input: props.number.toString(),
		};
	}

	componentDidUpdate(prevProps: Props) {
		if (prevProps.number !== this.props.number) {
			this.setState({
				input: this.props.number.toString(),
			});
		}
	}

	onInputChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
		this.setState({
			input: evt.target.value,
		});
	};

	confirmChange = () => {
		const { edit } = this.props;
		const { input } = this.state;
		const score = +input;
		if (!Number.isNaN(score)) {
			edit(score);
		}
	};

	render() {
		const { number, label } = this.props;
		const { input } = this.state;

		return (
			<Col>
				<Row alignCenter>
					<div>{label}</div>
					<Spacer horizontal={20} />
					<div>
						<input
							value={input}
							onChange={this.onInputChange}
							style={{
								fontSize: '28px',
							}}
						/>
					</div>
				</Row>
				{input !== number.toString() && (
					<button
						onClick={this.confirmChange}
						style={{
							fontSize: '20px',
						}}
					>
						Confirm change from {number} to {input}
					</button>
				)}
			</Col>
		);
	}
}

export default NumberEditor;
